import { CSSProperties } from "react"
import { colors, css, fonts } from "../Styles"
  
export enum TableStyles_Types {
  primaryTable = "primaryTable",
  secondaryTable = "secondaryTable",
  newSecondaryTable = "newSecondaryTable",
  tertiaryTable = "tertiaryTable",
  newTertiaryTable = "newTertiaryTable",
  animalTable = "animalTable",
  feedCurveTable = "feedCurveTable",
  blueTable = "blueTable"
}

export const CreateTableStyle = (index: number, tableType?: TableStyles_Types | string) => {
  let tableStyle: CSSProperties = {};
  let headCellStyle: CSSProperties = {};
  let bodyCellStyle: (colIndex: number) => CSSProperties = () => ({});
  let bottomCellStyle: CSSProperties = {};

  /*eslint no-fallthrough: "error"*/
  switch (tableType) {
    case TableStyles_Types.secondaryTable:
      tableStyle = {
        ...css.tableStyle,
        maxHeight: "99%",
        backgroundColor: colors.greyLightSecondary,
        border: "5px solid"+colors.greyPrimary,
        borderRadius: "0px 0px 10px 10px",
        overflowY: "scroll",
        overflowX: "scroll",
        scrollbarColor: colors.greySecondary + colors.greyPrimary,
      };
      headCellStyle = {
        ...css.headCellStyle,
        height: "20px",
        backgroundColor: colors.greyPrimary,
        outline: "4px solid",
        outlineColor: colors.greyPrimary,
        outlineOffset: "-3px",
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle,
      });
      bottomCellStyle = {
        ...css.bottomCellStyle,
        backgroundColor: colors.greyPrimary,
        outline: "4px solid",
        outlineColor: colors.greyPrimary,
        outlineOffset: "-3px",
      }
    break;
    case TableStyles_Types.tertiaryTable:
      tableStyle = {
        ...css.tableStyle,
      };
      headCellStyle = {
        ...css.headCellStyle,
        // fontSize: fonts.fontSize4.fontSize,
        // color: colors.greyPrimary,
        // backgroundColor: colors.greyLightPrimary,
        // padding: "5px 10px"
        padding: "0"
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle,
        padding: "0px 10px"
      });
      bottomCellStyle = {
        ...css.bottomCellStyle
      }
    break;
    case TableStyles_Types.newSecondaryTable:
      tableStyle = {
        ...css.tableStyle,
        borderRadius: "0px",
        height: "fit-content",
        maxHeight: "200px",
        scrollbarColor: colors.greyLightPrimary+colors.transparent,
      };
      headCellStyle = {
        ...css.headCellStyle,
        color: colors.greyDarkPrimary,
        backgroundColor: colors.greyLightTertiary,
        padding: "10px 0px 5px 16px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "start",
        gap: "10px"
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle,
      });
      bottomCellStyle = {
        ...css.bottomCellStyle
      }
    break;
    case TableStyles_Types.newTertiaryTable:
      tableStyle = {
        ...css.tableStyle,
        // height: "100%",
        maxHeight: "100%",
        height: "fit-content",
        borderRadius: "0px",
        scrollbarColor: colors.greySecondary+colors.greyPrimary,
      };
      headCellStyle = {
        ...css.headCellStyle,
        backgroundColor: colors.greyPrimary,
        padding: "10px 0px 5px 16px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "start",
        gap: "10px"
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle,
      });
      bottomCellStyle = {
        ...css.bottomCellStyle,
        backgroundColor: colors.greyPrimary
      }
    break;
    case TableStyles_Types.animalTable:
      tableStyle = {
        ...css.tableStyle,
        // height: "100%",
        maxHeight: "100%",
        height: "fit-content",
        borderRadius: "0px",
        // paddingBottom: "100px",
        scrollbarColor: colors.greySecondary+colors.greyPrimary,
      };
      headCellStyle = {
        ...css.headCellStyle,
        backgroundColor: colors.greyPrimary,
        padding: "10px 0px 5px 16px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "start",
        gap: "10px"
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle,
      });
      bottomCellStyle = {
        ...css.bottomCellStyle,
        backgroundColor: colors.greyPrimary
      }
    break;
    case TableStyles_Types.blueTable:
      tableStyle = {
        ...css.tableStyle,
        borderRadius: "0px 0px 10px 10px",
        scrollbarColor: colors.greyLightPrimary+colors.greyLightSecondary
      };
      headCellStyle = {
        ...css.headCellStyle,
        height: "20px",
        backgroundColor: colors.blueDarkPrimary,
        outline: "4px solid",
        outlineColor: colors.blueDarkPrimary,
        outlineOffset: "-3px",
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle,
      });
      bottomCellStyle = {
        ...css.bottomCellStyle,
      }
    break;
    case TableStyles_Types.feedCurveTable: 
      // headCellStyle, bodyCellStyle and bottomCellStyle is in feedCurveTable.tsx and feedCurveTableEdit.tsx
      tableStyle = {
        ...css.tableStyle,
        maxHeight: "100%",
        backgroundColor: colors.greyDarkSecondary,
        border: "5px solid"+colors.greyPrimary,
        // borderLeft: "5px solid"+colors.greyPrimary,
        // borderBottom: "5px solid"+colors.greyPrimary,
        // borderRight: "5px solid"+colors.greyPrimary,
        overflowY: "scroll",
        overflowX: "scroll",
        scrollbarColor: colors.greySecondary + colors.greyPrimary,
        borderRadius: "10px",
      };
      headCellStyle = {        
        ...css.headCellStyle,
        height: "40px",
        position: "sticky",
        top: "0px !important",
        borderRight: index === 1 ? `2px solid ${colors.greySecondary}` : "none",
        // borderLeft: index === content.length - 2 ? `2px solid ${colors.greySecondary}` : "none",
        backgroundColor: colors.greyPrimary,
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle,
      });
      bottomCellStyle = {
        ...css.bottomCellStyle,
        backgroundColor: colors.greyPrimary,
        outline: "4px solid",
        outlineColor: colors.greyPrimary,
        outlineOffset: "-3px",
      }
    break;
    case TableStyles_Types.primaryTable:
    default:
      tableStyle = {
        ...css.tableStyle
      };
      headCellStyle = {
        ...css.headCellStyle
      };
      bodyCellStyle = (colIndex: number) => ({
        ...css.bodyCellStyle
      });
      bottomCellStyle = {
        ...css.bottomCellStyle
      }
  }
  return {
    tableStyle, headCellStyle, bodyCellStyle, bottomCellStyle
  };
};

// Eksempel på brug (Maja) - se evt. tableList.tsx
//
// Import af definition:
// import CreateTableStyle, {TableStyles_Types} from "../../Definitions/tableStyles"
// 
// Indsæt under props for det pågældende component:
// tableType?: TableStyles_Types | string,
//
// Kald på de forskellige componenter, hvor stylingen ønskes:
// <TableList
// tableType={TableStyles_Types.secondaryTable}
// />